import * as ambassadorWixCalendarV3Event from './calendar-v3-event-events.http.js';
import * as ambassadorWixCalendarV3EventTypes from './calendar-v3-event-events.types.js';
import * as ambassadorWixCalendarV3EventUniversalTypes from './calendar-v3-event-events.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function listEventsByContactId(): __PublicMethodMetaInfo<
  'GET',
  { contactId: string },
  ambassadorWixCalendarV3EventUniversalTypes.ListEventsByContactIdRequest,
  ambassadorWixCalendarV3EventTypes.ListEventsByContactIdRequest,
  ambassadorWixCalendarV3EventUniversalTypes.ListEventsByContactIdResponse,
  ambassadorWixCalendarV3EventTypes.ListEventsByContactIdResponse
> {
  const payload = { contactId: ':contactId' } as any;

  const getRequestOptions =
    ambassadorWixCalendarV3Event.listEventsByContactId(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/events/contactId/{contactId}',
    pathParams: { contactId: 'contactId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listEventsByMemberId(): __PublicMethodMetaInfo<
  'GET',
  { memberId: string },
  ambassadorWixCalendarV3EventUniversalTypes.ListEventsByMemberIdRequest,
  ambassadorWixCalendarV3EventTypes.ListEventsByMemberIdRequest,
  ambassadorWixCalendarV3EventUniversalTypes.ListEventsByMemberIdResponse,
  ambassadorWixCalendarV3EventTypes.ListEventsByMemberIdResponse
> {
  const payload = { memberId: ':memberId' } as any;

  const getRequestOptions =
    ambassadorWixCalendarV3Event.listEventsByMemberId(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/events/memberId/{memberId}',
    pathParams: { memberId: 'memberId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getEvent(): __PublicMethodMetaInfo<
  'GET',
  { eventId: string },
  ambassadorWixCalendarV3EventUniversalTypes.GetEventRequest,
  ambassadorWixCalendarV3EventTypes.GetEventRequest,
  ambassadorWixCalendarV3EventUniversalTypes.GetEventResponse,
  ambassadorWixCalendarV3EventTypes.GetEventResponse
> {
  const payload = { eventId: ':eventId' } as any;

  const getRequestOptions = ambassadorWixCalendarV3Event.getEvent(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/events/{eventId}',
    pathParams: { eventId: 'eventId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listEvents(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixCalendarV3EventUniversalTypes.ListEventsRequest,
  ambassadorWixCalendarV3EventTypes.ListEventsRequest,
  ambassadorWixCalendarV3EventUniversalTypes.ListEventsResponse,
  ambassadorWixCalendarV3EventTypes.ListEventsResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixCalendarV3Event.listEvents(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/events',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryEvents(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixCalendarV3EventUniversalTypes.QueryEventsRequest,
  ambassadorWixCalendarV3EventTypes.QueryEventsRequest,
  ambassadorWixCalendarV3EventUniversalTypes.QueryEventsResponse,
  ambassadorWixCalendarV3EventTypes.QueryEventsResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixCalendarV3Event.queryEvents(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/events/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createEvent(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixCalendarV3EventUniversalTypes.CreateEventRequest,
  ambassadorWixCalendarV3EventTypes.CreateEventRequest,
  ambassadorWixCalendarV3EventUniversalTypes.CreateEventResponse,
  ambassadorWixCalendarV3EventTypes.CreateEventResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixCalendarV3Event.createEvent(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/events',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkCreateEvent(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixCalendarV3EventUniversalTypes.BulkCreateEventRequest,
  ambassadorWixCalendarV3EventTypes.BulkCreateEventRequest,
  ambassadorWixCalendarV3EventUniversalTypes.BulkCreateEventResponse,
  ambassadorWixCalendarV3EventTypes.BulkCreateEventResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixCalendarV3Event.bulkCreateEvent(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/events/create',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateEvent(): __PublicMethodMetaInfo<
  'PATCH',
  { eventId: string },
  ambassadorWixCalendarV3EventUniversalTypes.UpdateEventRequest,
  ambassadorWixCalendarV3EventTypes.UpdateEventRequest,
  ambassadorWixCalendarV3EventUniversalTypes.UpdateEventResponse,
  ambassadorWixCalendarV3EventTypes.UpdateEventResponse
> {
  const payload = { event: { id: ':eventId' } } as any;

  const getRequestOptions = ambassadorWixCalendarV3Event.updateEvent(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v3/events/{event.id}',
    pathParams: { eventId: 'eventId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateEvent(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixCalendarV3EventUniversalTypes.BulkUpdateEventRequest,
  ambassadorWixCalendarV3EventTypes.BulkUpdateEventRequest,
  ambassadorWixCalendarV3EventUniversalTypes.BulkUpdateEventResponse,
  ambassadorWixCalendarV3EventTypes.BulkUpdateEventResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixCalendarV3Event.bulkUpdateEvent(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/events/update',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function restoreEventDefaults(): __PublicMethodMetaInfo<
  'POST',
  { eventId: string },
  ambassadorWixCalendarV3EventUniversalTypes.RestoreEventDefaultsRequest,
  ambassadorWixCalendarV3EventTypes.RestoreEventDefaultsRequest,
  ambassadorWixCalendarV3EventUniversalTypes.RestoreEventDefaultsResponse,
  ambassadorWixCalendarV3EventTypes.RestoreEventDefaultsResponse
> {
  const payload = { eventId: ':eventId' } as any;

  const getRequestOptions =
    ambassadorWixCalendarV3Event.restoreEventDefaults(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/events/{eventId}/restore-defaults',
    pathParams: { eventId: 'eventId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function splitRecurringEvent(): __PublicMethodMetaInfo<
  'POST',
  { recurringEventId: string },
  ambassadorWixCalendarV3EventUniversalTypes.SplitRecurringEventRequest,
  ambassadorWixCalendarV3EventTypes.SplitRecurringEventRequest,
  ambassadorWixCalendarV3EventUniversalTypes.SplitRecurringEventResponse,
  ambassadorWixCalendarV3EventTypes.SplitRecurringEventResponse
> {
  const payload = { recurringEventId: ':recurringEventId' } as any;

  const getRequestOptions =
    ambassadorWixCalendarV3Event.splitRecurringEvent(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/events/{recurringEventId}/split',
    pathParams: { recurringEventId: 'recurringEventId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function cancelEvent(): __PublicMethodMetaInfo<
  'POST',
  { eventId: string },
  ambassadorWixCalendarV3EventUniversalTypes.CancelEventRequest,
  ambassadorWixCalendarV3EventTypes.CancelEventRequest,
  ambassadorWixCalendarV3EventUniversalTypes.CancelEventResponse,
  ambassadorWixCalendarV3EventTypes.CancelEventResponse
> {
  const payload = { eventId: ':eventId' } as any;

  const getRequestOptions = ambassadorWixCalendarV3Event.cancelEvent(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/events/{eventId}/cancel',
    pathParams: { eventId: 'eventId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkCancelEvent(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixCalendarV3EventUniversalTypes.BulkCancelEventRequest,
  ambassadorWixCalendarV3EventTypes.BulkCancelEventRequest,
  ambassadorWixCalendarV3EventUniversalTypes.BulkCancelEventResponse,
  ambassadorWixCalendarV3EventTypes.BulkCancelEventResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixCalendarV3Event.bulkCancelEvent(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/events/cancel',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Event as EventOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  ZonedDate as ZonedDateOriginal,
  RecurrenceType as RecurrenceTypeOriginal,
  RecurrenceTypeWithLiterals as RecurrenceTypeWithLiteralsOriginal,
  RecurrenceRule as RecurrenceRuleOriginal,
  Frequency as FrequencyOriginal,
  FrequencyWithLiterals as FrequencyWithLiteralsOriginal,
  Day as DayOriginal,
  DayWithLiterals as DayWithLiteralsOriginal,
  Transparency as TransparencyOriginal,
  TransparencyWithLiterals as TransparencyWithLiteralsOriginal,
  Location as LocationOriginal,
  LocationType as LocationTypeOriginal,
  LocationTypeWithLiterals as LocationTypeWithLiteralsOriginal,
  Resource as ResourceOriginal,
  Role as RoleOriginal,
  RoleWithLiterals as RoleWithLiteralsOriginal,
  Participants as ParticipantsOriginal,
  Participant as ParticipantOriginal,
  ParticipantsStatus as ParticipantsStatusOriginal,
  ParticipantsStatusWithLiterals as ParticipantsStatusWithLiteralsOriginal,
  ConferencingDetails as ConferencingDetailsOriginal,
  ProviderType as ProviderTypeOriginal,
  ProviderTypeWithLiterals as ProviderTypeWithLiteralsOriginal,
  OnlineMeetingInfo as OnlineMeetingInfoOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  Provider as ProviderOriginal,
  ProviderProviderInfoOneOf as ProviderProviderInfoOneOfOriginal,
  Field as FieldOriginal,
  FieldWithLiterals as FieldWithLiteralsOriginal,
  Permission as PermissionOriginal,
  CommonIdentificationData as CommonIdentificationDataOriginal,
  CommonIdentificationDataIdOneOf as CommonIdentificationDataIdOneOfOriginal,
  IdentityType as IdentityTypeOriginal,
  IdentityTypeWithLiterals as IdentityTypeWithLiteralsOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  RecurringEventSplit as RecurringEventSplitOriginal,
  EventCancelled as EventCancelledOriginal,
  ParticipantNotification as ParticipantNotificationOriginal,
  EventUpdatedWithMetadata as EventUpdatedWithMetadataOriginal,
  UpdateScheduleWithFixedBusinessResourceIdRequest as UpdateScheduleWithFixedBusinessResourceIdRequestOriginal,
  UpdateScheduleWithFixedBusinessResourceIdResponse as UpdateScheduleWithFixedBusinessResourceIdResponseOriginal,
  UpdateEventsWithFixedBusinessResourceIdRequest as UpdateEventsWithFixedBusinessResourceIdRequestOriginal,
  UpdateEventsWithFixedBusinessResourceIdResponse as UpdateEventsWithFixedBusinessResourceIdResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  ListEventsByContactIdRequest as ListEventsByContactIdRequestOriginal,
  CommonCursorPaging as CommonCursorPagingOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  ListEventsByContactIdResponse as ListEventsByContactIdResponseOriginal,
  CommonCursorPagingMetadata as CommonCursorPagingMetadataOriginal,
  CommonCursors as CommonCursorsOriginal,
  ListEventsByMemberIdRequest as ListEventsByMemberIdRequestOriginal,
  ListEventsByMemberIdResponse as ListEventsByMemberIdResponseOriginal,
  SitePropertiesNotification as SitePropertiesNotificationOriginal,
  SitePropertiesEvent as SitePropertiesEventOriginal,
  Properties as PropertiesOriginal,
  Categories as CategoriesOriginal,
  Locale as LocaleOriginal,
  Address as AddressOriginal,
  AddressHint as AddressHintOriginal,
  PlacementType as PlacementTypeOriginal,
  PlacementTypeWithLiterals as PlacementTypeWithLiteralsOriginal,
  GeoCoordinates as GeoCoordinatesOriginal,
  BusinessSchedule as BusinessScheduleOriginal,
  TimePeriod as TimePeriodOriginal,
  DayOfWeek as DayOfWeekOriginal,
  DayOfWeekWithLiterals as DayOfWeekWithLiteralsOriginal,
  SpecialHourPeriod as SpecialHourPeriodOriginal,
  Multilingual as MultilingualOriginal,
  SupportedLanguage as SupportedLanguageOriginal,
  ResolutionMethod as ResolutionMethodOriginal,
  ResolutionMethodWithLiterals as ResolutionMethodWithLiteralsOriginal,
  ConsentPolicy as ConsentPolicyOriginal,
  Translation as TranslationOriginal,
  ChangeContext as ChangeContextOriginal,
  ChangeContextPayloadOneOf as ChangeContextPayloadOneOfOriginal,
  PropertiesChange as PropertiesChangeOriginal,
  SiteCreated as SiteCreatedOriginal,
  SiteCloned as SiteClonedOriginal,
  Empty as EmptyOriginal,
  GetEventRequest as GetEventRequestOriginal,
  RequestedFields as RequestedFieldsOriginal,
  RequestedFieldsWithLiterals as RequestedFieldsWithLiteralsOriginal,
  GetEventResponse as GetEventResponseOriginal,
  ListEventsRequest as ListEventsRequestOriginal,
  ListEventsResponse as ListEventsResponseOriginal,
  QueryEventsRequest as QueryEventsRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryEventsResponse as QueryEventsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  ListRecurringEventInstancesHistoryRequest as ListRecurringEventInstancesHistoryRequestOriginal,
  ListRecurringEventInstancesHistoryResponse as ListRecurringEventInstancesHistoryResponseOriginal,
  CreateEventRequest as CreateEventRequestOriginal,
  CreateEventResponse as CreateEventResponseOriginal,
  BulkCreateEventRequest as BulkCreateEventRequestOriginal,
  MaskedEvent as MaskedEventOriginal,
  BulkCreateEventResponse as BulkCreateEventResponseOriginal,
  BulkEventResult as BulkEventResultOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  UpdateEventRequest as UpdateEventRequestOriginal,
  UpdateEventResponse as UpdateEventResponseOriginal,
  BulkUpdateEventRequest as BulkUpdateEventRequestOriginal,
  BulkUpdateEventRequestMaskedEvent as BulkUpdateEventRequestMaskedEventOriginal,
  BulkUpdateEventResponse as BulkUpdateEventResponseOriginal,
  UpdateEventParticipantsRequest as UpdateEventParticipantsRequestOriginal,
  UpdateEventParticipantsResponse as UpdateEventParticipantsResponseOriginal,
  RestoreEventDefaultsRequest as RestoreEventDefaultsRequestOriginal,
  RestoreEventDefaultsResponse as RestoreEventDefaultsResponseOriginal,
  SplitRecurringEventRequest as SplitRecurringEventRequestOriginal,
  SplitRecurringEventResponse as SplitRecurringEventResponseOriginal,
  CancelEventRequest as CancelEventRequestOriginal,
  CancelEventResponse as CancelEventResponseOriginal,
  BulkCancelEventRequest as BulkCancelEventRequestOriginal,
  BulkCancelEventResponse as BulkCancelEventResponseOriginal,
  CancelEventApplicationErrors as CancelEventApplicationErrorsOriginal,
  BulkCancelEventApplicationErrors as BulkCancelEventApplicationErrorsOriginal,
} from './calendar-v3-event-events.types.js';
